import { render, staticRenderFns } from "./BaseSentimentPieChart.vue?vue&type=template&id=031e64ec&"
import script from "./BaseSentimentPieChart.vue?vue&type=script&lang=js&"
export * from "./BaseSentimentPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports